import { render, staticRenderFns } from "./WorkSwitch.vue?vue&type=template&id=1a035e1e"
import script from "./WorkSwitch.vue?vue&type=script&lang=js"
export * from "./WorkSwitch.vue?vue&type=script&lang=js"
import style0 from "./WorkSwitch.vue?vue&type=style&index=0&id=1a035e1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports